import gql from 'graphql-tag';

const CAREERS_QUERY = gql`
  query getCareers{
    getCareers {
      title,
      link,
      short_description,
      background_image,
    }
  }
`;

export default CAREERS_QUERY;



// WEBPACK FOOTER //
// ./src/graphql/queries/careers.query.js